import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import './PageLoader.css';
import { useTranslation } from '../../hooks/useTranslation';

const PageLoader: React.FC = () => {
    const { language } = useTranslation();

    const loadingMessagesEn = [
        "🩺 Setting up your health camp dashboard... Please wait!",
        "💉 Preparing wellness insights... Almost there!",
        "👩‍⚕️ Bringing care to communities... Loading your data!",
        "🚑 Mobilizing medical support... Hang tight!",
        "🧬 Promoting healthier lives... Getting things ready!",
        "📋 Organizing patient records... Just a moment!",
        "🌡️ Checking vitals... Your health data is on the way!",
        "🧑‍⚕️ Coordinating doctors and volunteers... Loading now!",
        "🫶 Caring for every life... Please hold on!",
        "🏥 Creating impact through healthcare... Preparing your view!",
    ];

    const loadingMessagesMr = [
        "🩺 आरोग्य शिबिर डॅशबोर्ड सेट करत आहोत... कृपया प्रतीक्षा करा!",
        "💉 निरोगीपणाबद्दल माहिती तयार करत आहोत... थोडा वेळ थांबा!",
        "👩‍⚕️ समुदायांची काळजी घेत आहोत... तुमचा डेटा लोड होत आहे!",
        "🚑 वैद्यकीय मदत पोहोचवत आहोत... धीर धरा!",
        "🧬 सुदृढ जीवनाला प्रोत्साहन देत आहोत... तयारी सुरू आहे!",
        "📋 रुग्णांच्या नोंदी व्यवस्थित करत आहोत... फक्त एक क्षण!",
        "🌡️ शारीरिक स्थिती तपासत आहोत... तुमची माहिती येत आहे!",
        "🧑‍⚕️ डॉक्टर आणि स्वयंसेवकांचे समन्वय साधत आहोत... लोड होत आहे!",
        "🫶 प्रत्येक जीवाचे रक्षण... कृपया थांबा!",
        "🏥 आरोग्याद्वारे सकारात्मक बदल घडवत आहोत... डॅशबोर्ड तयार होत आहे!",
    ];

    // Select the message list based on the current language
    const currentMessages = language === 'mr' ? loadingMessagesMr : loadingMessagesEn;

    const [messageIndex, setMessageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setMessageIndex((prevIndex) => (prevIndex + 1) % currentMessages.length);
        }, 900);
        return () => clearInterval(interval);
    }, [currentMessages.length]);

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                margin: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
                flexDirection: 'column'
            }}
        >
            <div className="medical-loader"></div>

            <Typography
                variant="h5"
                sx={{
                    mb: 1,
                    color: '#000',
                    margin: '20px 20px !important',
                    fontWeight: '600',
                    textAlign: 'center',
                    maxWidth: '80%' // Helps with Marathi text wrapping
                }}
            >
                {currentMessages[messageIndex]}
            </Typography>
        </div>
    );
};

export default PageLoader;